import { useEffect, useState } from "react";

export const useCombinations = (coefs: any[]) => {
  const [combArray, setCombArray] = useState<any[]>([]);
  useEffect(() => {
    coefs &&
      setCombArray([
        {
          title: "Royal Flush",
          coef: coefs[8],
          win: 9,
        },
        {
          title: "Straight Flush",
          coef: coefs[7],
          win: 8,
        },
        {
          title: "Four of a Kind",
          coef: coefs[6],
          win: 7,
        },
        {
          title: "Full House",
          coef: coefs[5],
          win: 6,
        },
        {
          title: "Flush",
          coef: coefs[4],
          win: 5,
        },
        {
          title: "Straight",
          coef: coefs[3],
          win: 4,
        },
        {
          title: "Three of a Kind",
          coef: coefs[2],
          win: 3,
        },
        {
          title: "Two Pairs",
          coef: coefs[1],
          win: 2,
        },
        {
          title: "Jacks or better",
          coef: coefs[0],
          win: 1,
        },
      ]);
  }, [coefs]);

  return [combArray];
};
